import { Badge, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import { CALCULATION_TYPE } from 'domains/payment-method/constants'
import { CommissionStatusBadge } from 'domains/seller-product-commission/atoms'

const propTypes = {
  commission            : PropTypes.object,
  onClickUpdate         : PropTypes.func,
  onClickChangeIsActive : PropTypes.func
}

const CommissionTableRow = ({
  commission,
  onClickUpdate,
  onClickChangeIsActive
}) => {

  const buttonClassName       = 'align-self-center my-1 mx-auto'
  const formatAbsoluteValue   = (row) => (row ? StringUtil.currencyCase(row) : 'Rp 0.0')
  const formatPercentageValue = (row) => (row ? `${StringUtil.transformToPercentage(row)}%` : '0%')

  const EmptyValueBadge = () => (
    <Badge color={ 'warning' }>
      { '-' }
    </Badge>
  )

  const EnableButton = () => (
    <Button
      onClick={
        () => onClickChangeIsActive(commission?.id, commission?.is_active)
      }
      size='sm'
      color='success'
      className={ buttonClassName }
    >
      { 'Enable' }
    </Button>
  )

  const DisableButton = () => (
    <Button
      onClick={
        () => onClickChangeIsActive(commission?.id, commission?.is_active)
      }
      size='sm'
      color='danger'
      className= { buttonClassName }
    >
      { 'Disable' }
    </Button>
  )

  return (
    <tr>
      <td>{ commission?.id }</td>
      <td>{ commission?.name }</td>
      <td>{ formatAbsoluteValue(commission?.price_from) }</td>
      <td>{ formatAbsoluteValue(commission?.price_to) }</td>
      <td>{ StringUtil.titleCase(commission?.calculation_type) }</td>
      <td>
        {
          commission?.calculation_type === CALCULATION_TYPE.ABSOLUTE
            ? formatAbsoluteValue(commission?.absolute_value)
            : <EmptyValueBadge />
        }
      </td>
      <td>
        {
          commission?.calculation_type === CALCULATION_TYPE.PERCENTAGE
            ? formatPercentageValue(commission?.percentage)
            : <EmptyValueBadge />
        }
      </td>
      <td>{ StringUtil.humanize(commission?.contract?.type_of) }</td>
      <td>{ StringUtil.humanize(commission?.payable_to) }</td>
      <td><CommissionStatusBadge is_active={ commission?.is_active } /></td>
      <td className="d-flex flex-column">
        <Button
          size='sm'
          color='primary'
          className={ buttonClassName }
          onClick={
            () => onClickUpdate(commission)
          }
        >
          { 'Update' }
        </Button>

        {
          commission?.is_active
            ? <DisableButton />
            : <EnableButton />
        }
      </td>
    </tr>
  )
}

CommissionTableRow.propTypes = propTypes
export default CommissionTableRow